import { z } from 'zod';

const inspectionItemSchema = z.object({
  description: z.string().trim().min(1, '請填寫檢測項目'),
  result: z.enum(['PASS', 'FAIL', 'NOT_APPLICABLE']),
});

/** 可編欄位；serialNo／itemName／accessories／problemDescription 為唯讀快照，不進 schema。 */
export const repairReportFormSchema = z.object({
  repairDate: z.string().optional().nullable(),
  resolution: z.string().optional().nullable(),
  remark: z.string().optional().nullable(),
  inspectionConclusion: z.string().optional().nullable(),
  inspectionItems: z.array(inspectionItemSchema).optional().default([]),
});

export const REPAIR_REPORT_FIELD_LABELS = {
  repairDate: '維修日',
  resolution: '處理方式',
  remark: '備註',
  inspectionConclusion: '檢測結論',
  inspectionItems: '檢測項目',
  'inspectionItems.description': '項目說明',
  'inspectionItems.result': '結果',
};
